import { render, staticRenderFns } from "./name.vue?vue&type=template&id=f69dedc0&scoped=true&"
import script from "./name.vue?vue&type=script&lang=js&"
export * from "./name.vue?vue&type=script&lang=js&"
import style0 from "./name.vue?vue&type=style&index=0&id=f69dedc0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f69dedc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f69dedc0')) {
      api.createRecord('f69dedc0', component.options)
    } else {
      api.reload('f69dedc0', component.options)
    }
    module.hot.accept("./name.vue?vue&type=template&id=f69dedc0&scoped=true&", function () {
      api.rerender('f69dedc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personalCenter/myInformation/name.vue"
export default component.exports